<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-auth-dialog"
  >
    <auth-form
      :product-list="productList"
      :is-edit="false"
      ref="outform"
      @submit="submit"
    ></auth-form>
  </sliderBarDialogShell>
</template>

<script>
import authForm from "@/components/authorize/authForm";

import { addAuth } from "@/api/authorize";

export default {
  name: "addAuthDialog",
  components: {
    authForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    productList: {
      type: Array,
      default(){
        return [];
      }
    },
  },

  data() {
    return {
      title: '新增授权码'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      // 每日授权码不支持批量，在提交边界钳一次：authForm 的 typechange 只在用户手动
      // 操作下拉时触发，程序化设置 type 的路径不经过它
      const generateCount = form.type === 3 ? 1 : (form.generateCount || 1);
      let params = {
        userName: form.name,
        phone: form.phone,
        authorizedProducts: form.productType.join(','),
        beginDate: form.startTime,
        endDate: form.endTime,
        type:form.type,
        // 非超管表单里没有该项，恒为默认值 1
        generateCount
      }
      if(form.recommender){
        params.referrer = form.recommender;
      }
      return addAuth(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: generateCount > 1 ? `成功生成 ${generateCount} 个授权码` : '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          // 当前不可达：非 200 会被响应拦截器 reject，走下面的 catch。
          // 保留作为该 url 一旦进 noCodeUrl 白名单后的兜底
          this.$message.error(data.msg);
        }
      }).catch(() => {
        // 拦截器已弹出后端 msg（utils/ajax.js 的 $vs.notify），这里只消化 rejection，
        // 避免 unhandled promise rejection；弹窗保持打开，用户改完可重提交
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-auth-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}

</style>
